import EntityId from '../../../../foundation/domain/EntityId';
import Lesson from '../domain/aggregates/lesson/Lesson';
import Api from '../../../../foundation/api/Api';
import Registry from '../../../global/Registry';

export default class LessonApi extends Api<Lesson> {

	private static instance?: LessonApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().lessonRepository);
	}

	public async getAll () {
		return await this.getList('/api/lessons');
	}

	public async getById (lessonId: EntityId<Lesson>) {
		return this.getOne(['/api/lessons/', lessonId]);
	}

	public async save (lesson: Lesson) {
		const data = {
			courseId: lesson.getCourseId().getValue(),
			title: lesson.getTitle(),
			subtitle: lesson.getSubtitle(),
			content: lesson.getContent(),
			active: lesson.isActive(),
			prerequisiteLessonIds: lesson.getPrerequisiteLessonIds().map(lessonId => lessonId.getValue()),
			position: { x: lesson.getPosition().getX(), y: lesson.getPosition().getY() }
		};

		return this.postOne('/api/lessons' + (lesson.hasId() ? '/' + lesson.getId().getValue() : ''), data);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/api/LessonApi.ts